module.exports = __webpack_public_path__ + "static/img/img_culture_f-1.6bab6cce.png";